(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-upsells"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__upsellRecs) return;
    window.__upsellRecs = 1;

    const initUpsellSlider = (slot) => {
      if (!window.Alpine || typeof window.Alpine.initTree !== 'function') {
        document.addEventListener('alpine:initialized', () => {
          window.Alpine.initTree(slot);
        }, { once: true });
        return;
      }
      window.Alpine.initTree(slot);
    };

    for (const el of document.querySelectorAll('[data-product-upsells-fallback]')) {
      if (el.dataset.loaded) continue;
      el.dataset.loaded = '1';

      const io = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting) return;
        io.disconnect();

        const url = el.getAttribute('data-url');
        if (!url) {
          el.remove();
          return;
        }

        fetch(url)
          .then((r) => {
            if (!r.ok) throw new Error();
            return r.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const recs = parsed.querySelector('[data-product-upsells-recs]');
            const slot = el.querySelector('[data-product-upsells-target]');
            if (!recs || !slot || !recs.innerHTML.trim()) {
              el.remove();
              return;
            }

            const title = el.getAttribute('data-title');
            if (title) {
              const wrap = document.createElement('div');
              wrap.className = 'mb-3 flex w-full md:mb-4';
              const heading = document.createElement('h2');
              heading.className = 'text-sc-body-primary text-base font-bold leading-6';
              heading.textContent = title;
              wrap.appendChild(heading);
              el.insertBefore(wrap, slot);
            }

            slot.innerHTML = recs.innerHTML;
            initUpsellSlider(slot);
          })
          .catch(() => el.remove());
      }, { rootMargin: '0px 0px 200px 0px' });

      io.observe(el);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
